module.exports = __webpack_public_path__ + "static/media/assorted-dressed-foods.e7d3f6c6.jpg";